import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams, useLocation } from 'react-router-dom';

import { updateHeaderColor, updateMobileHeaderColor } from '../../utils/scroll';
import HeaderComponents from '../../components/Header/HeaderComponents';
import SideBannerComponents from '../../components/SideBanner/SideBannerComp';
import ReferenceModal from '../../components/Modal/ReferenceModal';
import SearchInput from '../../components/Input/SearchInput';
import Pagination from '../../components/Paging/Pagination';

import { fetchRefListData } from '../../services/refService';

import { SERVER_URL, isMobile } from '../../config';

import useInput from '../../hooks/useInput';

import { refOptions } from './SupportData';
import S from './Support.module.css';

const ReferencePage = () => {

  const [ searchParams ] = useSearchParams();
  const pageIdx = searchParams.get('pageIdx') || 1;
  
  const [ refSearch, setRefSearch ] = useInput({ search: '' });
  const [ refData, setRefData ] = useState([]);
  const [ isModalOpen, setIsModalOpen ] = useState(false);
  const [ selectedFilePath, setSelectedFilePath ] = useState('');
  const [ correctPwd, setCorrectPwd ] = useState('');

  const [ pagingInfo, setPagingInfo ] = useState([]);
  const [ totalCnt, setTotalCnt ] = useState(0);
  
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 327);
  }, [location]);
  
  useEffect(() => {
    const wheelHandler = (e) => {
      if(isMobile()) {
        updateMobileHeaderColor();
      } else {
        updateHeaderColor();
      }
    };

    window.addEventListener('scroll', wheelHandler);

    return () => {
      window.removeEventListener('scroll', wheelHandler);
    };
  }, []);

  const refListData = async(searchVal, pageIdx) => {
    const response = await fetchRefListData(searchVal, pageIdx);
    setRefData(response.refList);
    setTotalCnt(response.totalCnt);
    setPagingInfo(response.pageInfo);
  };

  useEffect(() => {
    refListData(refSearch.search, pageIdx);
  }, [location, pageIdx]);
  
  const handleRefDivClick = (filePath, pwd) => {
    setSelectedFilePath(filePath);
    setCorrectPwd(pwd);
    if (pwd === null || pwd === '') {
      window.open(SERVER_URL + filePath, '_blank');
    } else {
      setIsModalOpen(true);
    }
  };

  const handlePasswordSubmit = (inputPwd) => {
    if (inputPwd === correctPwd) {
      window.open(SERVER_URL + selectedFilePath, '_blank');
      setIsModalOpen(false);
    } else {
      alert('틀린 비밀번호를 입력하였습니다.');
    }
  };

  const showRef = () => {
    if (refData.length === 0) {
      return <div className={S.noneSearch}>검색 결과가 없습니다.</div>;
    }
    
    const itemsPerRow = isMobile() ? 2 : 4;

    return (
      <div className={S.refListDiv}>
        {refData.map((item, index) => (
          index % itemsPerRow === 0 ? (
            <div className={S.refRowDiv} key={`row-${index}`}>
              {refData.slice(index, index + itemsPerRow).map((subItem) => (
                <div 
                  className={S.refDiv} 
                  key={subItem.R_IDX} 
                  onClick={() => handleRefDivClick(subItem.R_FILE_PATH, subItem.R_PWD)}
                >
                  <img className={S.refImg} src={SERVER_URL + subItem.R_IMG_PATH} alt='IMG'/>
                  <a className={S.refTitle}>{subItem.R_SUBJECT}</a>
                </div>
              ))}
            </div>
          ) : null
        ))}
      </div>
    );
  };

  const onPageChangeHandler = (pageNumber) => {
    navigate(`/support/reference?pageIdx=${pageNumber}`)
  };

  const handleSubmit = (e) => {
    if (e.key === 'Enter') {
      refListData(refSearch.search, 1);
      window.scrollTo(0, 327);
    }
  };

  return (
    <div>
      <HeaderComponents pageKey="support" />
      <div className='sideBannerComp flex-coulum'>
        <div>
          <SideBannerComponents pageKey="support" />
        </div>
        <div className='com-content-wrap mt-200'>
          {isMobile() ? (
            <>
              <div className={S.searchBar}>
                <SearchInput type='text' options={refOptions} name='search' value={refSearch.search} onChange={setRefSearch} onKeyPress={handleSubmit} selectclass={'searchSelect'} inputclass={'searchInput'}/>
              </div>
              {showRef()}
            </>
          ):(
            <>
              <div id={S.lineDiv}></div>
              {showRef()}
              <div className={S.searchBar}>
                <SearchInput type='text' options={refOptions} name='search' value={refSearch.search} onChange={setRefSearch} onKeyPress={handleSubmit} selectclass={'searchSelect'} inputclass={'searchInput'}/>
              </div>
            </>
          )}
          <Pagination 
            currentPage={pagingInfo.curPage}
            totalPages={pagingInfo.totalPage}
            onPageChangeHandler={onPageChangeHandler}
          />
        </div>
      </div>
      <ReferenceModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
        onSuccess={handlePasswordSubmit}
      />
    </div>
  );
};

export default ReferencePage;
